module.exports = __webpack_public_path__ + "media/images/visual2-68cd284fa37b4f933d55667afc5dfd58.png";